import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Tag, Spin, Empty, Tabs, Button, Avatar } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { expertsApi } from '../services/api';

const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const PageHeader = styled.div`
  margin-bottom: 24px;
`;

const ExpertCard = styled(Card)`
  transition: all 0.3s;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  }
`;

const expertTypes = [
  { code: 'all', name: '全部', icon: '👥' },
  { code: 'creation', name: '创作', icon: '🎵' },
  { code: 'distribution', name: '发行', icon: '📀' },
  { code: 'marketing', name: '营销', icon: '📢' },
  { code: 'data', name: '数据', icon: '📊' },
  { code: 'opc', name: 'OPC', icon: '🤖' },
];

function Experts() {
  const navigate = useNavigate();
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeType, setActiveType] = useState('all');

  useEffect(() => {
    fetchExperts();
  }, [activeType]);

  const fetchExperts = async () => {
    try {
      setLoading(true);
      const params = activeType === 'all' ? {} : { type: activeType };
      const res = await expertsApi.getExperts(params);
      setExperts(res.data.data || []);
    } catch (error) {
      console.error('获取专家失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSummon = (expertId, e) => {
    e.stopPropagation();
    navigate(`/expert-chat/${expertId}`);
  };

  const getTypeName = (code) => {
    const type = expertTypes.find(t => t.code === code);
    return type ? type.name : code;
  };

  return (
    <div>
      <PageHeader>
        <Title level={2}>音乐行业专家</Title>
        <Paragraph type="secondary">
          找到音乐行业各领域专家，获取AI智能体咨询服务
        </Paragraph>
      </PageHeader>

      <Tabs activeKey={activeType} onChange={setActiveType} style={{ marginBottom: 24 }}>
        {expertTypes.map(type => (
          <TabPane tab={`${type.icon} ${type.name}`} key={type.code} />
        ))}
      </Tabs>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '100px' }}>
          <Spin size="large" />
        </div>
      ) : experts.length === 0 ? (
        <Empty description="暂无专家" style={{ padding: '100px' }} />
      ) : (
        <Row gutter={[24, 24]}>
          {experts.map((expert) => (
            <Col span={8} key={expert.id}>
              <ExpertCard>
                {/* 头部：头像 + 名称 + 标签 */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                  <Avatar 
                    size={64} 
                    src={expert.avatar} 
                    style={{ background: '#f0f0f0' }}
                  >
                    {expert.name?.charAt(0)}
                  </Avatar>
                  <div style={{ marginLeft: 12, flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{expert.name}</div>
                    <div style={{ marginTop: 4 }}>
                      <Tag size="small">{getTypeName(expert.type)}</Tag>
                    </div>
                  </div>
                </div>
                
                {/* 简介 */}
                <Paragraph ellipsis={{ rows: 2 }} style={{ marginBottom: 12, color: '#666' }}>
                  {expert.bio || '暂无介绍'}
                </Paragraph>
                
                {/* 擅长标签 */}
                <div style={{ marginBottom: 12 }}>
                  {expert.capabilities?.slice(0, 3).map((cap, idx) => (
                    <Tag key={idx} size="small" style={{ marginBottom: 4 }}>{cap}</Tag>
                  ))}
                </div>
                
                {/* 召唤按钮 */}
                <Button 
                  type="primary" 
                  block
                  icon={<MessageOutlined />}
                  onClick={(e) => handleSummon(expert.id, e)}
                >
                  召唤专家
                </Button>
              </ExpertCard>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}

export default Experts;
